import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-kyc-final',
  templateUrl: './kyc-final.component.html',
  styleUrls: ['./kyc-final.component.css']
})
export class KycFinalComponent implements OnInit {
  status: 'ok' | 'ko' = 'ko'; // Valor predeterminado como 'ko'

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    // Lee el parámetro 'status' de la URL y establece el valor
    this.route.queryParams.subscribe(params => {
      this.status = params['status'] === 'ok' ? 'ok' : 'ko';
    });
  }

  // Método para navegar al panel de oportunidades solo cuando se hace clic en el botón
  navigateToOpportunities(): void {
    this.router.navigate(['/oportunidades']);
  }

  // Método para redirigir al inicio de sesión solo cuando se hace clic en el botón
  retryVerification(): void {
    this.router.navigate(['/login']);
  }
}
